import 'angular';

import { StatementsCtrl }   from './statements';
import { StatementsStates } from './statements.states.ajs';

angular.module('workshop.statements', [])
.config(StatementsStates)
.controller('StatementsCtrl', StatementsCtrl);